import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
// import initializeAnalytics from '../../utils/analytics/initializeAnalytics';

/**
 * Analitik araçları başlatan ve sayfa değişikliklerini takip eden bileşen
 * @returns {JSX.Element} - Analytics bileşeni
 */
const Analytics = () => {
  const [analyticsLoaded, setAnalyticsLoaded] = useState(false);
  
  // API anahtarlarını al
  const gtmId = process.env.REACT_APP_GTM_ID;
  
  useEffect(() => {
    // API anahtarlarının tanımlı olup olmadığını kontrol et
    
    // Eğer API anahtarları varsayılan değerlerini içeriyorsa (XXXXXXXX), gerçek anahtarlar tanımlanmamış demektir
    const hasRealApiKeys = (gtmId && !gtmId.includes('XXXXXXX'));
    
    if (!hasRealApiKeys) {
      console.warn('Analitik araçları için gerçek API anahtarları tanımlanmamış. Analitik verileri toplanmayacak.');
      return;
    }
    
    // Üretim ortamında her zaman, geliştirme ortamında ise yalnızca gerçek API anahtarları varsa analitik araçlarını yükle
    if (process.env.NODE_ENV === 'production' || hasRealApiKeys) {
      try {
        // Analitik araçlarını dinamik olarak yükle
        import('../../utils/analytics/initializeAnalytics').then(module => {
          const initializeAnalytics = module.default;
          initializeAnalytics();
          setAnalyticsLoaded(true);
          console.log('Analitik araçlar başarıyla başlatıldı');
          
          // Hangi analitik araçlarının başlatıldığını göster
          if (gtmId && !gtmId.includes('XXXXXXX')) console.log('Google Tag Manager başlatıldı:', gtmId);
        }).catch(error => {
          console.error('Analitik modülleri yüklenirken hata oluştu:', error);
        });
      } catch (error) {
        console.error('Analitik araçlar başlatılırken hata oluştu:', error);
      }
    } else {
      console.log('Geliştirme ortamında analitik araçlar devre dışı bırakıldı');
    }
  }, [gtmId]);

  // GTM zaten index.html'de ekli olduğu için burada tekrar yüklemeye gerek yok
  
  // Gerçek API anahtarları yoksa null döndür
  if (gtmId && gtmId.includes('XXXXXXX')) {
    return null;
  }

  return (
    <Helmet>
      {/* Çerez bildirimi kaldırıldı - CookieConsent bileşeni kullanılıyor */}
      
      {/* Not: Google Analytics ve Amplitude kodları kaldırıldı. Tüm analytics Google Tag Manager üzerinden yönetilecek */}
      
      {/* Analitik durumu */}
      {analyticsLoaded && (
        <meta name="analytics-status" content="loaded" />
      )}
    </Helmet>
  );
};

export default Analytics; 